import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {renderIf} from "../../../Shared";
import {GoDotFill} from 'react-icons/go'
import {Link} from 'react-router-dom'
import getLinkToDetail from '../../../../helpers/getLinkToDetail'
import classNames from "classnames";
import {GradeActionTypes} from '../../../AppLocals/Course'
import dayjs from "dayjs";

export const renderCourseClassGrade =
    ({renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) =>
        (item, index) => {
            const {subject, total_students_has_score, total_students, grade_date} = item ?? {}

            const dateObj = grade_date ? dayjs(grade_date) : null

            const percent_num = total_students > 0
                ? parseFloat(((total_students_has_score / total_students) * 100).toFixed(1))
                : 0

            let barColor = 'bg-color-100'
            let percentColor = 'text-color-300'
            let borderColor = 'border-transparent'
            if (total_students > 0) {
                if (percent_num >= 75) {
                    barColor = 'bg-green-500'
                    percentColor = 'text-green-600'
                    borderColor = 'border-green-400'
                } else if (percent_num >= 50) {
                    barColor = 'bg-amber-400'
                    percentColor = 'text-amber-500'
                    borderColor = 'border-amber-400'
                } else if (percent_num > 0) {
                    barColor = 'bg-color-200'
                    percentColor = 'text-color-300'
                    borderColor = 'border-color-200'
                }
            }

            return (
                <Translate key={index}>
                    {(t) => (
                        <div className={classNames(
                            "flex items-center gap-3 px-3 py-2.5 custom-item-render relative border-l-2",
                            borderColor
                        )}>
                            {/* Date badge */}
                            {dateObj ? (
                                <div
                                    className="flex flex-col items-center justify-center rounded-lg border border-color-100 px-2 py-1.5 flex-shrink-0 background-50"
                                    style={{minWidth: 44}}>
                                    <span className="text-sm font-bold text-color-100 leading-none">
                                        {dateObj.format('DD')}
                                    </span>
                                    <span className="text-2xs text-color-400 leading-tight mt-0.5">
                                        {dateObj.format('MM/YY')}
                                    </span>
                                </div>
                            ) : (
                                <div
                                    className="flex flex-col items-center justify-center rounded-lg border border-color-50 px-2 py-1.5 flex-shrink-0 background-50"
                                    style={{minWidth: 44}}>
                                    <span className="text-xs text-color-300">—</span>
                                </div>
                            )}

                            {/* Title + subject */}
                            <div
                                onClick={() => handleAction(GradeActionTypes.GRADE_DETAIL, item)}
                                className="flex-1 min-w-0 cursor-pointer flex flex-col gap-0.5">
                                <span className="font-bold text-sm text-color-000 hover:text-primary truncate">
                                    {getTitle(item)}
                                </span>
                                {subject && (
                                    <div className="flex items-center gap-1 text-xs italic text-color-400">
                                        <GoDotFill size={8} className="flex-shrink-0"/>
                                        <span className="truncate">{getTitle(subject)}</span>
                                    </div>
                                )}
                                {!!item?.course_class_exam?.id && (
                                    <div className="flex flex-wrap items-center gap-1 mt-0.5">
                                        {/* Exam đang mở */}
                                        {item?.course_class_exam?.status === 1 && (
                                            <Link
                                                to={getLinkToDetail(item?.course_class_exam)}
                                                onClick={e => e.stopPropagation()}
                                                className="text-2xs font-semibold px-1.5 py-0.5 rounded bg-indigo-50 text-indigo-500 no-underline hover:bg-indigo-100">
                                                {t('exam')}
                                            </Link>
                                        )}
                                        {/* Exam chưa khai báo — amber badge đã có onClick để edit, không cần thêm "edit exam" */}
                                        {item?.course_class_exam?.status === -1 && !!item?.edit && (
                                            <span
                                                onClick={e => {
                                                    e.stopPropagation()
                                                    handleAction(GradeActionTypes.COURSE_CLASS_EXAM_UPDATE, item?.course_class_exam)
                                                }}
                                                className="text-2xs font-semibold px-1.5 py-0.5 rounded bg-amber-50 text-amber-600 border border-amber-200 cursor-pointer hover:bg-amber-100">
                                                ⚠ {t('exam not declared')}
                                            </span>
                                        )}
                                        {/* Exam đã đóng */}
                                        {item?.course_class_exam?.status === 9 && (
                                            <span className="text-2xs font-semibold px-1.5 py-0.5 rounded bg-gray-50 text-gray-400 border border-gray-200">
                                                {t('exam closed')}
                                            </span>
                                        )}
                                        {/* Edit exam — chỉ hiện khi exam đã được khai báo (status !== -1) để tránh trùng với badge cảnh báo */}
                                        {!!item?.edit && item?.course_class_exam?.status !== -1 && (
                                            <span
                                                onClick={e => {
                                                    e.stopPropagation()
                                                    handleAction(GradeActionTypes.COURSE_CLASS_EXAM_UPDATE, item?.course_class_exam)
                                                }}
                                                className="text-2xs font-semibold text-indigo-400 hover:text-indigo-600 cursor-pointer">
                                                {t('edit exam')}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Graded stats */}
                            {total_students > 0 && (
                                <div className="flex flex-col items-end gap-0.5 flex-shrink-0">
                                    <div className="flex items-center gap-1.5">
                                        <div
                                            style={{width: 60}}
                                            className="h-1.5 rounded-full overflow-hidden bg-color-50 hidden sm:block">
                                            <div
                                                className={classNames("h-full rounded-full transition-all", barColor)}
                                                style={{width: `${Math.min(percent_num, 100)}%`}}
                                            />
                                        </div>
                                        <span className={classNames("font-bold text-xs text-right", percentColor)}>
                                            {percent_num.toFixed(1)}%
                                        </span>
                                    </div>
                                    <span className="text-2xs text-color-400 italic whitespace-nowrap">
                                        {`${total_students_has_score}/${total_students} ${t('graded')}`}
                                    </span>
                                </div>
                            )}

                            {renderIf(
                                item?.course_class?.edit && renderContextMenu,
                                <div className="contextIcon flex-shrink-0">
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )
        }
